var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wiki-users-wiki-in-list",
      class: { "wiki-users-wiki-in-list__in-list": _vm.inListStyle },
    },
    [
      _c("div", {}, [
        _c(
          "div",
          { staticClass: "wiki-users-wiki-in-list__image-part" },
          [
            _vm.wiki.userprofile
              ? _c("router-link", { attrs: { to: _vm.link } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.showOwner ? _vm.wikiOwner.name : "",
                          expression: "showOwner?wikiOwner.name:''",
                        },
                      ],
                      staticClass: "wiki-users-wiki-in-list__image-part__image",
                      style: _vm.leftAvatarStyle,
                      attrs: { alt: "" },
                    },
                    [
                      _vm.showOwner
                        ? _c("div", {
                            staticClass:
                              "wiki-users-wiki-in-list__image-part__image__inner-avatar",
                            style: {
                              "background-image": `url('${_vm.wikiOwner.avatar}')`,
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ])
              : _c("a", { attrs: { href: _vm.link } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.showOwner ? _vm.wikiOwner.name : "",
                          expression: "showOwner?wikiOwner.name:''",
                        },
                      ],
                      staticClass: "wiki-users-wiki-in-list__image-part__image",
                      style: _vm.leftAvatarStyle,
                      attrs: { alt: "" },
                    },
                    [
                      _vm.showOwner
                        ? _c("div", {
                            staticClass:
                              "wiki-users-wiki-in-list__image-part__image__inner-avatar",
                            style: {
                              "background-image": `url('${_vm.wikiOwner.avatar}')`,
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wiki-users-wiki-in-list__content-part" }, [
          _c(
            "div",
            {
              staticClass: "wiki-users-wiki-in-list__content-part__user-info",
              class: { "full-width": _vm.showOwner },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "wiki-users-wiki-in-list__content-part__user-info__wiki-name",
                },
                [
                  _vm.wiki.userprofile
                    ? _c("router-link", { attrs: { to: _vm.link } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.wiki.name) +
                            "\n                    "
                        ),
                      ])
                    : _c("a", { attrs: { href: _vm.link } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.wiki.name) +
                            "\n                    "
                        ),
                      ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.wiki.logo
                ? _c("div", [
                    _c("img", {
                      staticClass: "logo-image",
                      attrs: { alt: "Logo", height: 40, src: _vm.wiki.logo },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.wiki.description
                ? _c(
                    "div",
                    {
                      staticClass:
                        "wiki-users-wiki-in-list__content-part__user-info__description",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("cutName")(_vm.wiki.description, 150)) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.hiddenManagedWikisCount && !_vm.otherWikisIManage.length
        ? _c(
            "div",
            { staticClass: "wiki-users-wiki-in-list__expand-link-section" },
            [
              _c(
                "span",
                {
                  staticClass: "wiki-users-wiki-in-list__expand-link",
                  attrs: {
                    tabindex: "0",
                    role: "button",
                    "aria-label": "Show More",
                  },
                  on: { click: _vm.loadMoreManagedWikis },
                },
                [
                  _c("i", { staticClass: "fa fa-chevron-double-down" }),
                  _vm._v(
                    "Show " + _vm._s(_vm.hiddenManagedWikisCount) + " More"
                  ),
                  _c("i", { staticClass: "fa fa-chevron-double-down" }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.otherWikisIManage.length
        ? _c(
            "div",
            {},
            _vm._l(_vm.otherWikisIManage, function (wiki) {
              return _c("wikis-shared-list-wiki", {
                key: wiki.id,
                attrs: { wiki: wiki, "show-owner": false, "in-list-style": "" },
              })
            }),
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }